import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { agoraCoreNew, loginVideo, newLogin2, bgPreview, hsclLogo2 } from '../../assets/images';

export default function LandingPage() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div className="relative h-screen w-screen bg-[#0B1622] text-white overflow-hidden flex flex-col p-4 md:p-6 lg:p-8">
            {/* Background Layer - Simplified */}
            <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 bg-gradient-to-br from-[#0B1622] via-[#0B1622]/98 to-[#0B1622]/90"></div>
            </div>

            {/* Subtle glow blobs - White themed */}
            <div className="absolute top-1/2 left-1/4 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full filter blur-[120px] -z-10 animate-pulse-slow"></div>

            {/* Branded White Framing Border Container */}
            <div className={`relative z-10 flex-1 flex flex-col overflow-hidden transition-all duration-1000 ${isLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.98]'}`}>
                {/* Navbar - Frosted glass effect */}
                <nav className="relative z-50 w-full py-8 px-10 bg-white/5 backdrop-blur-2xl shadow-[0_4px_30px_rgba(0,0,0,0.1)]">
                    <div className="w-full flex items-center justify-between px-10">
                        <div className={`transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
                            <img
                                src={agoraCoreNew}
                                alt="AgoraCore"
                                className="h-32 w-auto object-contain brightness-110"
                            />
                        </div>

                        {/* <div className={`flex items-center gap-10 transition-all duration-1000 delay-300 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
                            <Link
                                to="/auth-login"
                                className="px-8 py-3 bg-[#6CBC50] hover:bg-[#5aa341] text-white rounded-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#6CBC50]/20"
                            >
                                Sign In
                            </Link>
                        </div> */}
                    </div>
                </nav>

                {/* Main Split Content */}
                <main className="relative z-10 flex-1 container mx-auto px-10 lg:px-20 flex items-center py-12">
                    <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-16 lg:gap-24 w-full min-h-0">

                        {/* Left Side: Messaging */}
                        <div className="flex flex-col items-start space-y-28">
                            <div className="space-y-16">
                                <h1 className={`text-5xl lg:text-6xl xl:text-7xl font-black leading-[1.4] tracking-tight transition-all duration-1000 delay-500 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                                    Manage Smarter. <br />
                                    Grow Faster.
                                </h1>

                                <p className={`text-2xl lg:text-3xl text-gray-400 font-light max-w-xl leading-[1.6] transition-all duration-1000 delay-700 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                                    The All-in-One ERP-Platform for Modern Enterprises
                                </p>
                            </div>

                            <div className={`flex flex-wrap gap-8 pt-4 transition-all duration-1000 delay-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                                <Link
                                    to="/auth-login"
                                    className="px-10 py-4 bg-[#012E80] hover:bg-[#011a4d] text-white text-lg font-black rounded-lg transition-all duration-300 transform hover:scale-110 flex items-center gap-4 group"
                                >
                                    Get Started
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 transition-transform group-hover:translate-x-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                    </svg>
                                </Link>

                                <button className="px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white text-lg font-bold rounded-lg transition-all duration-300 backdrop-blur-sm">
                                    Watch Demo
                                </button>
                            </div>
                        </div>

                        {/* Right Side: Hero Section with Background constrained */}
                        <div className={`relative flex justify-center items-center transition-all duration-1500 delay-[800ms] ${isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'}`}>
                            {/* Background Image constrained to this section */}
                            <div className="absolute inset-0 z-0 flex items-center justify-center opacity-30 select-none pointer-events-none overflow-hidden">
                                <img
                                    src={bgPreview}
                                    alt=""
                                    className="w-full h-full object-contain animate-slow-zoom"
                                />
                            </div>

                            <div className="relative group perspective-1000 z-10 w-full flex justify-center">
                                <div className="absolute -inset-4 bg-white/5 rounded-full blur-[80px] -z-10 group-hover:bg-white/10 transition-all duration-1000"></div>
                                <img
                                    src={newLogin2}
                                    alt="Dashboard Visualization"
                                    className="relative z-10 w-full max-w-[600px] max-h-[60vh] object-contain drop-shadow-[0_20px_60px_rgba(0,0,0,0.6)] transform group-hover:rotate-y-3 group-hover:scale-105 transition-all duration-1000"
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            {/* Footer - Powered by HSCL (Moved to root for absolute screen bottom) */}
            <footer className={`absolute bottom-4 left-0 w-full z-50 flex justify-center items-center transition-all duration-1000 delay-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
                <div className="flex items-center gap-2 group cursor-default scale-90 opacity-60 hover:opacity-100 transition-opacity duration-300">
                    <span className="font-light tracking-[0.2em] text-[10px] uppercase text-white">Powered by</span>
                    <img
                        src={hsclLogo2}
                        alt="HSCL"
                        className="h-7 w-auto object-contain brightness-110 transition-all duration-300 group-hover:brightness-150"
                    />
                </div>
            </footer>

            <style jsx>{`
                @keyframes pulse-slow {
                    0%, 100% { opacity: 0.1; transform: translate(-50%, -50%) scale(1); }
                    50% { opacity: 0.2; transform: translate(-50%, -50%) scale(1.1); }
                }
                @keyframes slow-zoom {
                    from { transform: scale(1); }
                    to { transform: scale(1.15); }
                }
                .animate-pulse-slow {
                    animation: pulse-slow 8s infinite ease-in-out;
                }
                .animate-slow-zoom {
                    animation: slow-zoom 20s infinite alternate ease-in-out;
                }
                .perspective-1000 {
                    perspective: 1000px;
                }
                .rotate-y-3 {
                    transform: rotateY(3deg);
                }
                :global(body) {
                    overflow: hidden;
                    margin: 0;
                    padding: 0;
                }
            `}</style>
        </div>
    );
}
